import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-modal-info',
  templateUrl: './modal-info.component.html',
  styleUrls: ['./modal-info.component.scss']
})
export class ModalInfoComponent {
  @Input() titulo: string = ''
  @Input() texto: string = ''
  @Input() modalId = 'modal-info'
}
